import { $Qll, $Q } from '../utils/querySelector';
import axios from 'axios';

/**
 * makes an api call to know what is the available quantity for a given product
 *
 * @param {string} productId
 */
const getProductQuantity = (productId) => {
  const apiKey = 'fc155e79abd4955eb94c4987d3466195';
  const request = axios.post(
    '/api/2022-04/graphql.json',
    `
    {
      product(id: "gid://shopify/Product/${productId}") {
        totalInventory,
        variants(first: 1) {
          edges {
            node {
              id,
              quantityAvailable
            }
          }
        }
      }
    }
  `,
    {
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': apiKey,
      },
    }
  );

  return request.then((response) => response.data.data);
};

/**
 * Updates the select input for the given wrapper element to the maximum
 * quantity
 *
 * @param {HTMLDivElement} wrapperElement
 * @param {number} quantityAvailable
 */
const updateSelectInputForProduct = (wrapperElement, quantityAvailable) => {
  const selectInput = $Q('select[id*="zqtyn"]', wrapperElement);

  selectInput.innerHTML = '';

  const fragment = document.createDocumentFragment();
  const dummyOption = document.createElement('option');

  if (quantityAvailable <= 0) {
    selectInput.remove();
    return;
  }

  new Array(quantityAvailable).fill(0).forEach((_, index) => {
    const option = dummyOption.cloneNode(true);

    option.setAttribute('value', index + 1);
    option.innerHTML = index + 1;

    fragment.append(option);
  });

  selectInput.appendChild(fragment);
};

(() => {
  if (window.location.href.includes('pages/wishlist')) {
    let previouslyExecuted = false;
    document.addEventListener('DOMContentLoaded', () => {
      const observer = new MutationObserver(async (mutations) => {
        const canApplyObserver = mutations.some((mutation) =>
          mutation.target.classList.contains('ZoomyWishlistPageGrid')
        );

        if (canApplyObserver && !previouslyExecuted) {
          previouslyExecuted = true;
          const products = $Qll('.ZoomyWishlistPageGrid');

          for (const product of products) {
            const productId = product
              .getAttribute('id')
              .replace('ZoomyWishlistPageGrid-', '');
            const shopifyData = await getProductQuantity(productId);

            if (shopifyData.product) {
              const {
                product: {
                  variants: {
                    edges: [{ node: variant }],
                  },
                },
              } = shopifyData;

              const { quantityAvailable } = variant;

              updateSelectInputForProduct(product, quantityAvailable);
            }
          }
        }
      });

      const productList = $Q('.account__outlet');

      observer.observe(productList, { childList: true, subtree: true });
    });
  }
})();
